import Swiper, { Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

document.addEventListener("DOMContentLoaded", function () {
	//fetch the notification bar (if it exists)
	let notification_bar = document.getElementById('lro-announcement-bar');

	//if the notification bar is present and we have more than one notice
	if (notification_bar && notification_bar.dataset.notices > 1) {

		//configure notification bar swiper
		const notification_bar_swiper = new Swiper(notification_bar , {
			modules: [Autoplay, EffectFade],
			autoHeight: false,
			autoplay: {
				delay: 3000,
			},
			effect: 'fade',
			loop: true,
			slidesPerView: 1
		});

		document.addEventListener('click', function (event) {

			//if the clicked element is a play/pause button
			if (event.target.matches('.lro-announcement-play') || event.target.matches('.lro-announcement-pause')) {

				//check whether we need to play or pause
				let play = event.target.matches('.lro-announcement-play');

				//if we need to play
				if(play) {

					//resume autoplay
					notification_bar_swiper.autoplay.start();
				} else { //otherwise we need to pause

					//so stop the autoplay
					notification_bar_swiper.autoplay.stop();
				}

				//fetch both play/pause buttons
				let buttons = notification_bar.getElementsByClassName('lro-aoouncement-playpause');

				//if we have buttons
				if(buttons) {

					//loop over them
					for (let button of buttons) {

						//toggle the hidden class
						button.classList.toggle('hidden');
					}
				}
			}
		}, false);
	}
});